export default {
  SET_LANGUAGES: (state, languages) => {
    state.languages = languages;
  },

  SET_SELECTED_LANGUAGE: (state, languageId) => {
    state.selectedLanguage = languageId;
  },
};
